var script_loaded = !1;

function loadJSscripts() {
    if (!script_loaded) {
        script_loaded = !0;
        
        // 1. Immediately remove the event listeners so they don't clog the main thread
        activityEvents.forEach(function(t) {
            window.removeEventListener(t, loadJSscripts, !1);
        });

        // 2. Load the iframes
        document.querySelectorAll("iframe.lazy").forEach(t => {
            var datasrc = t.dataset.src;
            if (datasrc != null) t.src = datasrc;
        });

        // 3. Load the scripts
        var t = document.getElementsByTagName("script");
        for (var i = 0; i < t.length; i++) {
            if (t[i].getAttribute("data-src") !== null) {
                t[i].setAttribute("src", t[i].getAttribute("data-src"));
                delete t[i].dataset.src;
            }
            if (t[i].getAttribute("type") == "text/lazyload") {
                var e = document.createElement("script");
                for (var a = 0; a < t[i].attributes.length; a++) {
                    var n = t[i].attributes[a];
                    e.setAttribute(n.name, n.value);
                }
                e.type = "text/javascript";
                e.innerHTML = t[i].innerHTML;
                t[i].parentNode.removeChild(t[i]);
                t[i].parentNode.insertBefore(e, t[i]);
            }
        }

        // 4. Load the links
        var r = document.getElementsByTagName("link");
        for (var i = 0; i < r.length; i++) {
            if (r[i].getAttribute("data-href") !== null) {
                r[i].setAttribute("href", r[i].getAttribute("data-href"));
                delete r[i].dataset.href;
            }
        }
        
        document.dispatchEvent(new CustomEvent("asyncLazyLoad"));
    }
}

// 5. Use 'once: true' and 'passive: true' for massive performance gains
var activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click", "keypress", "touchmove"];
activityEvents.forEach(function(t) {
    window.addEventListener(t, loadJSscripts, { once: true, passive: true });
});